export const iconSizes = {
    "2xs": "w-2.5 h-2.5",
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-7 h-7",
    "2xl": "w-8 h-8",
    "3xl": "w-9 h-9",
    "4xl": "w-10 h-10",
};

export const icons = {
    /**
     *
     */
    LCM: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 20">
            <path d="M10.8333 3.33333V0.833333L15.8333 5.83333H13.3333C11.5778 5.83333 10.8333 5.08889 10.8333 3.33333ZM16.6667 7.5V16.6667C16.6667 18.8889 15.5556 20 13.3333 20H3.33333C1.11111 20 0 18.8889 0 16.6667V3.33333C0 1.11111 1.11111 0 3.33333 0H9.16667V3.33333C9.16667 6.02222 10.6444 7.5 13.3333 7.5H16.6667ZM11.7 9.78056C11.375 9.45556 10.8472 9.45556 10.5222 9.78056L7.40833 12.8944L6.14444 11.6306C5.81944 11.3056 5.29167 11.3056 4.96667 11.6306C4.64167 11.9556 4.64167 12.4833 4.96667 12.8083L6.81944 14.6611C6.975 14.8167 7.18611 14.9056 7.40833 14.9056C7.63056 14.9056 7.84167 14.8167 7.99722 14.6611L11.7 10.9583C12.025 10.6333 12.025 10.1056 11.7 9.78056Z" />
        </svg>
    ),
    PTL: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
            <path
                d="M62.709,402.754a9.061,9.061,0,0,1-3.474-2.483,22.085,22.085,0,0,1,2.233-.406,11.239,11.239,0,0,0,1.241,2.89"
                transform="translate(-57.084 -385.408)"
            />
            <path
                d="M172.38,391.935c-.726,2.317-1.876,3.723-2.954,3.723s-2.229-1.4-2.954-3.719c.872-.068,1.846-.115,2.937-.115s2.083.043,2.971.111"
                transform="translate(-160.426 -377.658)"
            />
            <path
                d="M344.251,400.008a9.093,9.093,0,0,1-3.5,2.518,11.371,11.371,0,0,0,1.245-2.9c.923.12,1.679.256,2.259.38"
                transform="translate(-328.372 -385.18)"
            />
            <path
                d="M389.214,271.463a8.869,8.869,0,0,1-1.116,3.582,25.746,25.746,0,0,0-2.894-.539,20.3,20.3,0,0,0,.322-3.043Z"
                transform="translate(-371.214 -261.649)"
            />
            <path
                d="M153.849,271.463a19.722,19.722,0,0,1-.322,2.868c-1-.086-2.126-.141-3.375-.141s-2.362.056-3.341.141a19.717,19.717,0,0,1-.322-2.868Z"
                transform="translate(-141.169 -261.649)"
            />
            <path
                d="M4.01,274.515a21.415,21.415,0,0,0-2.864.573A8.816,8.816,0,0,1,0,271.463H3.687a20.411,20.411,0,0,0,.322,3.052"
                transform="translate(0.001 -261.649)"
            />
            <path
                d="M4.01,126.728a20.409,20.409,0,0,0-.322,3.052H0a8.876,8.876,0,0,1,1.142-3.625,21.66,21.66,0,0,0,2.868.573"
                transform="translate(0.001 -121.594)"
            />
            <path
                d="M153.849,149.95h-7.36a19.716,19.716,0,0,1,.322-2.868c.979.085,2.087.141,3.341.141s2.375-.056,3.375-.141a19.721,19.721,0,0,1,.322,2.868"
                transform="translate(-141.169 -141.764)"
            />
            <path
                d="M389.214,130.92h-3.688a20.294,20.294,0,0,0-.322-3.043,25.773,25.773,0,0,0,2.894-.539,8.869,8.869,0,0,1,1.116,3.582"
                transform="translate(-371.214 -122.734)"
            />
            <path
                d="M344.251,20.608c-.58.124-1.335.261-2.259.38a11.369,11.369,0,0,0-1.245-2.9,9.092,9.092,0,0,1,3.5,2.518"
                transform="translate(-328.372 -17.436)"
            />
            <path
                d="M172.38,3.723c-.889.068-1.876.111-2.971.111s-2.065-.047-2.937-.115C167.2,1.4,168.348,0,169.426,0s2.229,1.406,2.954,3.723"
                transform="translate(-160.426 0)"
            />
            <path
                d="M62.709,18.09a11.3,11.3,0,0,0-1.241,2.89c-.945-.128-1.692-.274-2.233-.4a9.026,9.026,0,0,1,3.474-2.488"
                transform="translate(-57.084 -17.436)"
            />
        </svg>
    ),
    Portal: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
            <path
                d="M62.709,402.754a9.061,9.061,0,0,1-3.474-2.483,22.085,22.085,0,0,1,2.233-.406,11.239,11.239,0,0,0,1.241,2.89"
                transform="translate(-57.084 -385.408)"
            />
            <path
                d="M172.38,391.935c-.726,2.317-1.876,3.723-2.954,3.723s-2.229-1.4-2.954-3.719c.872-.068,1.846-.115,2.937-.115s2.083.043,2.971.111"
                transform="translate(-160.426 -377.658)"
            />
            <path
                d="M344.251,400.008a9.093,9.093,0,0,1-3.5,2.518,11.371,11.371,0,0,0,1.245-2.9c.923.12,1.679.256,2.259.38"
                transform="translate(-328.372 -385.18)"
            />
            <path
                d="M389.214,271.463a8.869,8.869,0,0,1-1.116,3.582,25.746,25.746,0,0,0-2.894-.539,20.3,20.3,0,0,0,.322-3.043Z"
                transform="translate(-371.214 -261.649)"
            />
            <path
                d="M153.849,271.463a19.722,19.722,0,0,1-.322,2.868c-1-.086-2.126-.141-3.375-.141s-2.362.056-3.341.141a19.717,19.717,0,0,1-.322-2.868Z"
                transform="translate(-141.169 -261.649)"
            />
            <path
                d="M4.01,274.515a21.415,21.415,0,0,0-2.864.573A8.816,8.816,0,0,1,0,271.463H3.687a20.411,20.411,0,0,0,.322,3.052"
                transform="translate(0.001 -261.649)"
            />
            <path
                d="M4.01,126.728a20.409,20.409,0,0,0-.322,3.052H0a8.876,8.876,0,0,1,1.142-3.625,21.66,21.66,0,0,0,2.868.573"
                transform="translate(0.001 -121.594)"
            />
            <path
                d="M153.849,149.95h-7.36a19.716,19.716,0,0,1,.322-2.868c.979.085,2.087.141,3.341.141s2.375-.056,3.375-.141a19.721,19.721,0,0,1,.322,2.868"
                transform="translate(-141.169 -141.764)"
            />
            <path
                d="M389.214,130.92h-3.688a20.294,20.294,0,0,0-.322-3.043,25.773,25.773,0,0,0,2.894-.539,8.869,8.869,0,0,1,1.116,3.582"
                transform="translate(-371.214 -122.734)"
            />
            <path
                d="M344.251,20.608c-.58.124-1.335.261-2.259.38a11.369,11.369,0,0,0-1.245-2.9,9.092,9.092,0,0,1,3.5,2.518"
                transform="translate(-328.372 -17.436)"
            />
            <path
                d="M172.38,3.723c-.889.068-1.876.111-2.971.111s-2.065-.047-2.937-.115C167.2,1.4,168.348,0,169.426,0s2.229,1.406,2.954,3.723"
                transform="translate(-160.426 0)"
            />
            <path
                d="M62.709,18.09a11.3,11.3,0,0,0-1.241,2.89c-.945-.128-1.692-.274-2.233-.4a9.026,9.026,0,0,1,3.474-2.488"
                transform="translate(-57.084 -17.436)"
            />
        </svg>
    ),
    CGM: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M8.31111 9.05833C8.58889 9.18056 8.87778 9.25833 9.16667 9.325V19.9028C8.98889 19.8583 8.81111 19.7917 8.64445 19.7139L1.97778 16.7472C0.777778 16.2139 0 15.025 0 13.7028V6.30278C0 6.00278 0.0444444 5.70278 0.122222 5.425L8.31111 9.05833ZM13.1333 6.58056L4.07778 2.325L1.97778 3.25833C1.58889 3.425 1.25556 3.66944 0.966667 3.95833L8.97778 7.525C9.62222 7.81389 10.3667 7.81389 11.0222 7.525L13.1333 6.58056ZM19.0333 3.95833C18.7444 3.66944 18.4111 3.425 18.0222 3.25833L11.3556 0.291667C10.4889 -0.0972222 9.51111 -0.0972222 8.64445 0.291667L6.1 1.425L15.1556 5.68056L19.0333 3.95833ZM19.8778 5.425L15.9778 7.15833V9.88056C15.9778 10.3361 15.6 10.7139 15.1444 10.7139C14.6889 10.7139 14.3111 10.3361 14.3111 9.88056V7.89167L11.6889 9.05833C11.4111 9.16945 11.1222 9.25833 10.8333 9.325V19.9028C11.0111 19.8583 11.1889 19.7917 11.3556 19.7139L18.0222 16.7472C19.2222 16.2139 20 15.025 20 13.7028V6.30278C20 6.00278 19.9556 5.70278 19.8778 5.425Z" />
        </svg>
    ),
    OLM: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 20">
            <path d="M7.49883 20C2.94329 20 0 17.2192 0 12.9074C0 8.59553 5.86158 1.26543 6.53023 0.440556C7.00516 -0.146852 7.99875 -0.146852 8.47368 0.440556C9.14232 1.26543 15.0039 8.61428 15.0039 12.9074C15.0039 17.2004 12.0606 20 7.50508 20H7.49883Z" />
        </svg>
    ),
    SCT: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 21">
            <path d="M8.29108 9.12958C8.56819 9.25277 8.85639 9.33116 9.14458 9.39835V20.0593C8.96723 20.0145 8.78988 19.9473 8.62361 19.8689L1.97301 16.8789C0.775904 16.3414 0 15.1432 0 13.8106V6.35235C0 6.04999 0.0443373 5.74763 0.121928 5.46767L8.29108 9.12958ZM18.9875 3.98947C18.6993 3.69831 18.3667 3.45194 17.9788 3.28396L11.3282 0.293961C10.4636 -0.0979869 9.48819 -0.0979869 8.62361 0.293961L1.97301 3.28396C1.58506 3.45194 1.25253 3.69831 0.964337 3.98947L8.95614 7.58419C9.59904 7.87535 10.3417 7.87535 10.9957 7.58419L18.9875 3.98947ZM16.294 9.96107C17.4384 9.68951 18.5247 9.7763 19.5029 10.1151C19.7218 10.1906 19.9518 10.0395 19.9518 9.80429V6.34955C19.9518 6.04719 19.9075 5.74483 19.8299 5.46487L11.6607 9.12678C11.3836 9.23877 11.0954 9.32836 10.8072 9.39555V20.0565C10.8266 20.0705 10.8266 20.0705 10.8488 20.0817L12.7248 19.2362C12.916 19.1494 12.9714 18.9171 12.8551 18.7435C12.0542 17.5341 11.7134 15.9943 12.0376 14.3761C12.4699 12.2176 14.1713 10.465 16.294 9.96107ZM22.7561 20.7536C22.5927 20.9188 22.382 21 22.1687 21C21.9553 21 21.7419 20.9188 21.5812 20.7536L19.8631 19.0179C19.223 19.4406 18.4637 19.6926 17.6435 19.6926C15.4017 19.6926 13.5783 17.8504 13.5783 15.5855C13.5783 13.3206 15.4017 11.4785 17.6435 11.4785C19.8853 11.4785 21.7059 13.3206 21.7059 15.5855C21.7059 16.4142 21.4565 17.1841 21.0381 17.828L22.7561 19.5638C23.0804 19.8913 23.0804 20.4233 22.7561 20.7508V20.7536ZM20.0433 15.5855C20.0433 14.2473 18.9653 13.1582 17.6435 13.1582C16.3217 13.1582 15.241 14.2473 15.241 15.5855C15.241 16.9237 16.3189 18.0128 17.6435 18.0128C18.9681 18.0128 20.0433 16.9237 20.0433 15.5855Z" />
        </svg>
    ),
    ESW: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M19.7025 9.2925L16.9975 6.5875V4.0025C16.9975 3.4525 16.5475 3.0025 15.9975 3.0025H13.4125L10.7025 0.2925C10.3125 -0.0975 9.6775 -0.0975 9.2875 0.2925L6.5825 2.9975H3.9975C3.4475 2.9975 2.9975 3.4475 2.9975 3.9975V6.5825L0.2925 9.2925C-0.0975 9.6825 -0.0975 10.3175 0.2925 10.7075L2.9975 13.4125V15.9975C2.9975 16.5475 3.4475 16.9975 3.9975 16.9975H6.5825L9.2875 19.7025C9.4825 19.8975 9.7375 19.9975 9.9925 19.9975C10.2475 19.9975 10.5025 19.8975 10.6975 19.7025L13.4025 16.9975H15.9875C16.5375 16.9975 16.9875 16.5475 16.9875 15.9975V13.4125L19.6925 10.7075C20.0825 10.3175 20.0825 9.6825 19.6925 9.2925H19.7025Z" />
        </svg>
    ),
    LPCO: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M19.7025 9.2925L16.9975 6.5875V4.0025C16.9975 3.4525 16.5475 3.0025 15.9975 3.0025H13.4125L10.7025 0.2925C10.3125 -0.0975 9.6775 -0.0975 9.2875 0.2925L6.5825 2.9975H3.9975C3.4475 2.9975 2.9975 3.4475 2.9975 3.9975V6.5825L0.2925 9.2925C-0.0975 9.6825 -0.0975 10.3175 0.2925 10.7075L2.9975 13.4125V15.9975C2.9975 16.5475 3.4475 16.9975 3.9975 16.9975H6.5825L9.2875 19.7025C9.4825 19.8975 9.7375 19.9975 9.9925 19.9975C10.2475 19.9975 10.5025 19.8975 10.6975 19.7025L13.4025 16.9975H15.9875C16.5375 16.9975 16.9875 16.5475 16.9875 15.9975V13.4125L19.6925 10.7075C20.0825 10.3175 20.0825 9.6825 19.6925 9.2925H19.7025Z" />
        </svg>
    ),
    OSC: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M19.7025 9.2925L16.9975 6.5875V4.0025C16.9975 3.4525 16.5475 3.0025 15.9975 3.0025H13.4125L10.7025 0.2925C10.3125 -0.0975 9.6775 -0.0975 9.2875 0.2925L6.5825 2.9975H3.9975C3.4475 2.9975 2.9975 3.4475 2.9975 3.9975V6.5825L0.2925 9.2925C-0.0975 9.6825 -0.0975 10.3175 0.2925 10.7075L2.9975 13.4125V15.9975C2.9975 16.5475 3.4475 16.9975 3.9975 16.9975H6.5825L9.2875 19.7025C9.4825 19.8975 9.7375 19.9975 9.9925 19.9975C10.2475 19.9975 10.5025 19.8975 10.6975 19.7025L13.4025 16.9975H15.9875C16.5375 16.9975 16.9875 16.5475 16.9875 15.9975V13.4125L19.6925 10.7075C20.0825 10.3175 20.0825 9.6825 19.6925 9.2925H19.7025Z" />
        </svg>
    ),
    CLR: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 20">
            <path d="M16.5278 3.98C13.7861 3.98 11.1708 2.64 9.52778 0.379998C9.15833 -0.130002 8.34167 -0.130002 7.97222 0.379998C6.32917 2.64 3.71389 3.98 0.972222 3.98C0.4375 3.98 0 4.43 0 4.98V9.06C0 13.62 2.79028 17.77 6.94167 19.37L8.40972 19.94C8.51667 19.98 8.63333 20 8.75 20C8.86667 20 8.98333 19.98 9.09028 19.94L10.5583 19.37C14.7097 17.77 17.5 13.62 17.5 9.06V4.98C17.5 4.43 17.0625 3.98 16.5278 3.98Z" />
        </svg>
    ),
    PCL: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 20">
            <path d="M5.6 6.13333H4V4.53333C4 2.03733 6.03733 0 8.53333 0C11.0293 0 13.0667 2.03733 13.0667 4.53333V6.13333H11.4667V4.53333C11.4667 2.912 10.1547 1.6 8.53333 1.6C6.912 1.6 5.6 2.912 5.6 4.53333V6.13333ZM15.4667 6.13333H13.0667V9.33333C13.0667 9.77067 12.704 10.1333 12.2667 10.1333C11.8293 10.1333 11.4667 9.77067 11.4667 9.33333V6.13333H5.6V9.33333C5.6 9.77067 5.23733 10.1333 4.8 10.1333C4.36267 10.1333 4 9.77067 4 9.33333V6.13333H1.6C0.714667 6.13333 0 6.848 0 7.73333V16.8C0 18.9333 1.06667 20 3.2 20H13.8667C16 20 17.0667 18.9333 17.0667 16.8V7.73333C17.0667 6.848 16.352 6.13333 15.4667 6.13333Z" />
        </svg>
    ),
    COL: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 20">
            <path d="M14.4444 0H3.33333C1.11111 0 0 1.11111 0 3.33333V17.3583C0 18.275 1.04444 18.7972 1.77778 18.2472L3.28889 17.1139C3.95278 16.6167 4.88056 16.6833 5.46667 17.2694L7.71111 19.5139C8.36111 20.1639 9.41667 20.1639 10.0694 19.5139L12.3139 17.2694C12.9 16.6833 13.8278 16.6167 14.4917 17.1139L16.0028 18.2472C16.7361 18.7972 17.7806 18.275 17.7806 17.3583V3.33333C17.7806 1.11111 16.6694 0 14.4472 0H14.4444ZM10 11.9444H4.44444C3.98333 11.9444 3.61111 11.5722 3.61111 11.1111C3.61111 10.65 3.98333 10.2778 4.44444 10.2778H10C10.4611 10.2778 10.8333 10.65 10.8333 11.1111C10.8333 11.5722 10.4611 11.9444 10 11.9444ZM13.3333 7.5H4.44444C3.98333 7.5 3.61111 7.12778 3.61111 6.66667C3.61111 6.20556 3.98333 5.83333 4.44444 5.83333H13.3333C13.7944 5.83333 14.1667 6.20556 14.1667 6.66667C14.1667 7.12778 13.7944 7.5 13.3333 7.5Z" />
        </svg>
    ),
    Collection: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 20">
            <path d="M14.4444 0H3.33333C1.11111 0 0 1.11111 0 3.33333V17.3583C0 18.275 1.04444 18.7972 1.77778 18.2472L3.28889 17.1139C3.95278 16.6167 4.88056 16.6833 5.46667 17.2694L7.71111 19.5139C8.36111 20.1639 9.41667 20.1639 10.0694 19.5139L12.3139 17.2694C12.9 16.6833 13.8278 16.6167 14.4917 17.1139L16.0028 18.2472C16.7361 18.7972 17.7806 18.275 17.7806 17.3583V3.33333C17.7806 1.11111 16.6694 0 14.4472 0H14.4444ZM10 11.9444H4.44444C3.98333 11.9444 3.61111 11.5722 3.61111 11.1111C3.61111 10.65 3.98333 10.2778 4.44444 10.2778H10C10.4611 10.2778 10.8333 10.65 10.8333 11.1111C10.8333 11.5722 10.4611 11.9444 10 11.9444ZM13.3333 7.5H4.44444C3.98333 7.5 3.61111 7.12778 3.61111 6.66667C3.61111 6.20556 3.98333 5.83333 4.44444 5.83333H13.3333C13.7944 5.83333 14.1667 6.20556 14.1667 6.66667C14.1667 7.12778 13.7944 7.5 13.3333 7.5Z" />
        </svg>
    ),
    PCA: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M10.0028 0C4.48057 0 0.00279133 4.47778 0.00279133 9.99722C0.00279133 11.4861 0.336125 12.9083 0.925014 14.175C1.15835 14.6639 1.15835 15.2306 0.99168 15.7528L0.0583469 18.5306C-0.230542 19.3972 0.602791 20.2306 1.46946 19.9417L4.24724 19.0083C4.76946 18.8417 5.33612 18.8417 5.82501 19.075C7.09168 19.6639 8.5139 19.9972 10.0028 19.9972C15.525 19.9972 20 15.5194 20 9.99722C20 4.475 15.5222 0 10.0028 0ZM8.02224 14.4444H5.55557V11.9778L9.97779 7.53333L12.4667 10.0222L8.02224 14.4444ZM14.1556 8.34445L13.2445 9.24444L10.7556 6.75556L11.6556 5.84444C12.0445 5.45556 12.6667 5.45556 13.0556 5.84444L14.1556 6.94444C14.5445 7.33333 14.5445 7.95556 14.1556 8.34445Z" />
        </svg>
    ),
    EFM: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 18">
            <path d="M11.225 9.92778C11.225 11.2556 10.1444 12.3361 8.81667 12.3361C7.48889 12.3361 6.41111 11.2556 6.41111 9.92778C6.41111 8.6 7.49167 7.51944 8.81667 7.51944C10.1417 7.51944 11.225 8.6 11.225 9.92778ZM20 6.66667V14.4444C20 16.6667 18.8889 17.7778 16.6667 17.7778H3.33333C1.11111 17.7778 0 16.6667 0 14.4444V3.33333C0 1.11111 1.11111 0 3.33333 0H7.77778L11.1111 3.33333H16.6667C18.8889 3.33333 20 4.44444 20 6.66667ZM13.9444 13.875L12.2222 12.1528C12.6417 11.5111 12.8917 10.75 12.8917 9.92778C12.8917 7.68056 11.0639 5.85278 8.81667 5.85278C6.56944 5.85278 4.74444 7.68056 4.74444 9.92778C4.74444 12.175 6.57222 14.0028 8.81667 14.0028C9.63889 14.0028 10.4028 13.7528 11.0444 13.3333L12.7667 15.0556C12.9306 15.2194 13.1417 15.3 13.3556 15.3C13.5694 15.3 13.7833 15.2194 13.9444 15.0556C14.2694 14.7306 14.2694 14.2028 13.9444 13.8778V13.875Z" />
        </svg>
    ),
    ECT: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 20">
            <path d="M15.8333 5.83333H13.3333C11.5778 5.83333 10.8333 5.08889 10.8333 3.33333V0.833333L15.8333 5.83333ZM16.6667 7.5V16.6667C16.6667 18.8889 15.5556 20 13.3333 20H3.33333C1.11111 20 0 18.8889 0 16.6667V3.33333C0 1.11111 1.11111 0 3.33333 0H9.16667V3.33333C9.16667 6.02222 10.6444 7.5 13.3333 7.5H16.6667ZM9.72222 14.4444C9.72222 13.9833 9.35 13.6111 8.88889 13.6111H4.44444C3.98333 13.6111 3.61111 13.9833 3.61111 14.4444C3.61111 14.9056 3.98333 15.2778 4.44444 15.2778H8.88889C9.35 15.2778 9.72222 14.9056 9.72222 14.4444ZM13.0556 10C13.0556 9.53889 12.6833 9.16667 12.2222 9.16667H4.44444C3.98333 9.16667 3.61111 9.53889 3.61111 10C3.61111 10.4611 3.98333 10.8333 4.44444 10.8333H12.2222C12.6833 10.8333 13.0556 10.4611 13.0556 10Z" />
        </svg>
    ),
    AEO: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 20">
            <path d="M9.89638 15.829C9.89638 13.1319 12.0826 10.9472 14.7782 10.9472C15.6494 10.9472 16.4682 11.1763 17.176 11.5776C17.3818 10.7487 17.5 9.85552 17.5 8.88938V3.18885C13.1261 2.07677 10.9384 1.11062 8.76678 0C6.56305 1.11062 4.37682 2.07677 0 3.33333V8.88938C0 15.556 5.46848 18.8894 8.75073 20.0015C9.44542 19.7665 10.2379 19.4308 11.0552 18.9857C10.3328 18.1349 9.89638 17.033 9.89638 15.8304V15.829Z" />
            <path d="M17.7714 15.3284L16.7104 16.3543C16.6331 16.4288 16.598 16.5368 16.6155 16.6433L16.8578 18.0473C16.9074 18.3319 16.6068 18.5493 16.3499 18.4151L15.0773 17.751C14.9824 17.7014 14.8686 17.7014 14.7723 17.751L13.5011 18.4136C13.2428 18.5479 12.9422 18.3304 12.9918 18.0458L13.2341 16.6433C13.253 16.5368 13.2165 16.4288 13.1392 16.3543L12.0782 15.3284C11.8826 15.1401 11.9906 14.8103 12.2592 14.7723L13.7259 14.5607C13.8324 14.5447 13.9244 14.479 13.9725 14.3827L14.6088 13.1042C14.7373 12.8444 15.1094 12.8444 15.2393 13.1042L15.8756 14.3827C15.9238 14.479 16.0157 14.5461 16.1223 14.5607L17.589 14.7723C17.8575 14.8117 17.9655 15.1401 17.77 15.3284H17.7714Z" />
        </svg>
    ),
    CLB: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 23">
            <path d="M19.426 16.6981L14.6816 9.23736C14.4188 8.82319 14.2817 8.34619 14.2817 7.85775V1.7138H14.5702C15.0444 1.7138 15.4271 1.33105 15.4271 0.856898C15.4271 0.382748 15.0444 0 14.5702 0H5.42995C4.9558 0 4.57306 0.382748 4.57306 0.856898C4.57306 1.33105 4.9558 1.7138 5.42995 1.7138H5.71844V7.85775C5.71844 8.34619 5.58134 8.82319 5.31856 9.23736L0.574199 16.6981C-0.148452 17.832 -0.191297 19.2145 0.457089 20.3942C1.10548 21.5738 2.29371 22.2793 3.63904 22.2793H16.3611C17.7064 22.2793 18.8975 21.5767 19.5431 20.397C20.1915 19.2174 20.1458 17.8349 19.426 16.6981ZM6.76386 10.1542C7.20088 9.46587 7.43224 8.67181 7.43224 7.8549V1.7138H12.5679V7.85775C12.5679 8.67466 12.7993 9.46872 13.2363 10.1571L14.9501 12.8535H5.05006L6.76386 10.1542Z" />
        </svg>
    ),
    RKM: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 20">
            <path d="M22.2725 17.2092L12.8748 0.931226C12.16 -0.310409 10.3687 -0.310409 9.65107 0.931226L0.253382 17.2092C-0.461412 18.4508 0.432792 20 1.86523 20H20.6635C22.0959 20 22.9901 18.4508 22.2753 17.2092H22.2725ZM10.3887 8.15036C10.3887 7.67763 10.7703 7.29603 11.243 7.29603C11.7157 7.29603 12.0973 7.67763 12.0973 8.15036V11.5677C12.0973 12.0404 11.7157 12.422 11.243 12.422C10.7703 12.422 10.3887 12.0404 10.3887 11.5677V8.15036ZM11.2658 16.1242C10.6364 16.1242 10.121 15.6144 10.121 14.985C10.121 14.3557 10.625 13.8459 11.2544 13.8459H11.2658C11.8951 13.8459 12.4049 14.3557 12.4049 14.985C12.4049 15.6144 11.8951 16.1242 11.2658 16.1242Z" />
        </svg>
    ),
    EWC: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
            <path d="M21.1538 10.1538H18.8523V10.1708C18.4603 6.46744 15.5326 3.53974 11.8292 3.14769H11.8433V0.846154C11.8433 0.377949 11.4654 0 10.9972 0C10.529 0 10.151 0.377949 10.151 0.846154V3.14769H10.1651C6.4618 3.53974 3.5341 6.46744 3.14205 10.1708V10.1538H0.846154C0.377949 10.1538 0 10.5318 0 11C0 11.4682 0.377949 11.8462 0.846154 11.8462H3.14769V11.8292C3.53974 15.5326 6.46744 18.4603 10.1708 18.8523H10.1567V21.151C10.1567 21.6192 10.5346 21.9972 11.0028 21.9972C11.471 21.9972 11.849 21.6192 11.849 21.151V18.8495H11.8349C15.5382 18.4574 18.4659 15.5297 18.8579 11.8264V11.8433H21.1567C21.6249 11.8433 22.0028 11.4654 22.0028 10.9972C22.0028 10.529 21.6249 10.151 21.1567 10.151L21.1538 10.1538ZM11 13.8205C9.44308 13.8205 8.17949 12.5569 8.17949 11C8.17949 9.44308 9.44308 8.17949 11 8.17949C12.5569 8.17949 13.8205 9.44308 13.8205 11C13.8205 12.5569 12.5569 13.8205 11 13.8205Z" />
        </svg>
    ),
    /**
     *
     */
    login: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            transform="rotate(90)"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
            />
        </svg>
    ),
    logout: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            transform="rotate(90)"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5"
            />
        </svg>
    ),
    clipboard: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184"
            />
        </svg>
    ),
    snb_close: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12" />
        </svg>
    ),
    snb_open: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
        </svg>
    ),
    star: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
            />
        </svg>
    ),
    star_fill: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
            <path
                fillRule="evenodd"
                d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                clipRule="evenodd"
            />
        </svg>
    ),

    bars_arrow_down: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 4.5h14.25M3 9h9.75M3 13.5h9.75m4.5-4.5v12m0 0-3.75-3.75M17.25 21 21 17.25"
            />
        </svg>
    ),
    cloud_arrow_down: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9.75v6.75m0 0-3-3m3 3 3-3m-8.25 6a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z"
            />
        </svg>
    ),

    menu: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
        </svg>
    ),
    close: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
    ),
    up: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
        </svg>
    ),
    down: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    ),
    left: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
        </svg>
    ),
    right: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
        </svg>
    ),
    plus: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
        </svg>
    ),
    minus: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 12h-15" />
        </svg>
    ),

    home: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
            />
        </svg>
    ),
    search: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
            />
        </svg>
    ),
    calendar: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"
            />
        </svg>
    ),
    clock: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
    ),
    moon: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z"
            />
        </svg>
    ),
    sun: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
            />
        </svg>
    ),

    question: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"
            />
        </svg>
    ),
    eye: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
            />
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
    ),
    eyeSlash: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
            />
        </svg>
    ),
    loading: (
        <svg className="text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
        </svg>
    ),
    exclamation: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
            />
        </svg>
    ),
    exclamationTriangle: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
            />
        </svg>
    ),
    play: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
            />
        </svg>
    ),
    path: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
            />
        </svg>
    ),
    bell: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
            />
        </svg>
    ),
    out: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5"
            />
        </svg>
    ),
    envelope: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
            />
        </svg>
    ),
    list: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
            />
        </svg>
    ),
    funnel: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z"
            />
        </svg>
    ),
    arrowUp: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18" />
        </svg>
    ),
    bars: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
        </svg>
    ),
    barsDown: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 4.5h14.25M3 9h9.75M3 13.5h9.75m4.5-4.5v12m0 0-3.75-3.75M17.25 21 21 17.25"
            />
        </svg>
    ),
    barsUp: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 4.5h14.25M3 9h9.75M3 13.5h5.25m5.25-.75L17.25 9m0 0L21 12.75M17.25 9v12"
            />
        </svg>
    ),
    fileSearch: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Zm3.75 11.625a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
            />
        </svg>
    ),
    link: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244"
            />
        </svg>
    ),

    print: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Zm-3 0h.008v.008H15V10.5Z"
            />
        </svg>
    ),
    "pencil-alt": (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
            />
        </svg>
    ),
    "trash-alt": (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
            />
        </svg>
    ),
    check: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
        </svg>
    ),
    "folder-open": (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 9.776c.112-.017.227-.026.344-.026h15.812c.117 0 .232.009.344.026m-16.5 0a2.25 2.25 0 0 0-1.883 2.542l.857 6a2.25 2.25 0 0 0 2.227 1.932H19.05a2.25 2.25 0 0 0 2.227-1.932l.857-6a2.25 2.25 0 0 0-1.883-2.542m-16.5 0V6A2.25 2.25 0 0 1 6 3.75h3.879a1.5 1.5 0 0 1 1.06.44l2.122 2.12a1.5 1.5 0 0 0 1.06.44H18A2.25 2.25 0 0 1 20.25 9v.776"
            />
        </svg>
    ),
    megaphone: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 1 1 0-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 0 1-1.44-4.282m3.102.069a18.03 18.03 0 0 1-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 0 1 8.835 2.535M10.34 6.66a23.847 23.847 0 0 0 8.835-2.535m0 0A23.74 23.74 0 0 0 18.795 3m.38 1.125a23.91 23.91 0 0 1 1.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 0 0 1.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 0 1 0 3.46"
            />
        </svg>
    ),
    printer: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Zm-3 0h.008v.008H15V10.5Z"
            />
        </svg>
    ),

    download: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
            />
        </svg>
    ),
    globe: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 20"
            strokeWidth={1.2}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path d="M18.9998 10C18.9998 11.1819 18.767 12.3522 18.3147 13.4442C17.8624 14.5361 17.1994 15.5282 16.3637 16.364C15.528 17.1997 14.5358 17.8626 13.4439 18.3149C12.352 18.7672 11.1817 19 9.99976 19C8.81786 19 7.64754 18.7672 6.5556 18.3149C5.46367 17.8626 4.47152 17.1997 3.6358 16.364C2.80007 15.5282 2.13713 14.5361 1.68484 13.4442C1.23255 12.3522 0.999756 11.1819 0.999756 10C0.999756 7.61305 1.94797 5.32387 3.6358 3.63604C5.32362 1.94821 7.61281 1 9.99976 1C12.3867 1 14.6759 1.94821 16.3637 3.63604C18.0515 5.32387 18.9998 7.61305 18.9998 10Z" />
            <path d="M13.5998 10C13.5998 11.1817 13.5062 12.3525 13.3253 13.4442C13.1454 14.5358 12.8799 15.5276 12.5451 16.3636C12.2112 17.1997 11.8143 17.862 11.3778 18.3147C10.9405 18.7665 10.4725 18.9996 10 18.9996C9.52754 18.9996 9.05956 18.7665 8.62308 18.3147C8.1857 17.862 7.78882 17.1988 7.45494 16.3636C7.12016 15.5276 6.85467 14.5367 6.67378 13.4442C6.48926 12.3055 6.39776 11.1536 6.40019 10C6.40019 8.8184 6.49289 7.64756 6.67378 6.55591C6.85467 5.46426 7.12016 4.47251 7.45494 3.63646C7.78882 2.8004 8.1857 2.13803 8.62218 1.68535C9.05956 1.23448 9.52754 1.00049 10 1.00049C10.4725 1.00049 10.9405 1.23358 11.3769 1.68535C11.8143 2.13803 12.2112 2.8013 12.5451 3.63646C12.8799 4.47251 13.1454 5.46337 13.3253 6.55591C13.5071 7.64756 13.5998 8.8184 13.5998 10Z" />
            <path d="M1.00098 10H19.0001" strokeLinecap="round" />
        </svg>
    ),
    edit: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="#ffffff" viewBox="0 0 14 14">
            <g clipPath="url(#clip0_159_7039)">
                <path d="M3.88379 14H0V10.1162L6.96282 3.11841L10.8816 7.03718L3.88379 14Z" />
                <path d="M13.5408 4.3955L12.1063 5.81256L8.1875 1.89378L9.60456 0.459231C10.2169 -0.153077 11.1966 -0.153077 11.8089 0.459231L13.5408 2.19119C14.1531 2.8035 14.1531 3.78319 13.5408 4.3955Z" />
            </g>
            <defs>
                <clipPath id="clip0_159_7039">
                    <rect width="14" height="14" fill="white" />
                </clipPath>
            </defs>
        </svg>
    ),
    dark: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
            <path d="M9.13207 -0.00158691H9.14207C9.45957 -0.00158691 9.59957 0.390913 9.35957 0.598413C7.67957 2.04591 6.75457 4.32091 7.22707 6.77341C7.74957 9.49341 9.98957 11.5659 12.7746 11.9384C14.5346 12.1734 16.1621 11.7284 17.4571 10.8409C17.7196 10.6609 18.0696 10.8984 17.9896 11.2059C16.8846 15.5209 12.6271 18.5984 7.76707 17.9034C3.72957 17.3259 0.544573 14.0859 0.0645728 10.0934C-0.185427 8.01091 0.287073 6.04841 1.26707 4.41841C2.85957 1.77341 5.78707 -0.00158691 9.13207 -0.00158691Z" />
        </svg>
    ),
    light: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
            <path d="M13.1538 9C13.1538 11.2892 11.2915 13.1538 9 13.1538C6.70846 13.1538 4.84615 11.2892 4.84615 9C4.84615 6.71077 6.70846 4.84615 9 4.84615C11.2915 4.84615 13.1538 6.71077 13.1538 9ZM9.69231 2.53846V0.692308C9.69231 0.309231 9.38308 0 9 0C8.61692 0 8.30769 0.309231 8.30769 0.692308V2.53846C8.30769 2.92154 8.61692 3.23077 9 3.23077C9.38308 3.23077 9.69231 2.92154 9.69231 2.53846ZM9.69231 17.3077V15.4615C9.69231 15.0785 9.38308 14.7692 9 14.7692C8.61692 14.7692 8.30769 15.0785 8.30769 15.4615V17.3077C8.30769 17.6908 8.61692 18 9 18C9.38308 18 9.69231 17.6908 9.69231 17.3077ZM3.23077 9C3.23077 8.61692 2.92154 8.30769 2.53846 8.30769H0.692308C0.309231 8.30769 0 8.61692 0 9C0 9.38308 0.309231 9.69231 0.692308 9.69231H2.53846C2.92154 9.69231 3.23077 9.38308 3.23077 9ZM18 9C18 8.61692 17.6908 8.30769 17.3077 8.30769H15.4615C15.0785 8.30769 14.7692 8.61692 14.7692 9C14.7692 9.38308 15.0785 9.69231 15.4615 9.69231H17.3077C17.6908 9.69231 18 9.38308 18 9ZM4.92 4.92C5.19 4.65 5.19 4.21154 4.92 3.94154L3.61385 2.63538C3.34385 2.36538 2.90538 2.36538 2.63538 2.63538C2.36538 2.90538 2.36538 3.34385 2.63538 3.61385L3.94154 4.92C4.07769 5.05615 4.25308 5.12308 4.43077 5.12308C4.60846 5.12308 4.78615 5.05615 4.92 4.92ZM15.3646 15.3646C15.6346 15.0946 15.6346 14.6562 15.3646 14.3862L14.0585 13.08C13.7885 12.81 13.35 12.81 13.08 13.08C12.81 13.35 12.81 13.7885 13.08 14.0585L14.3862 15.3646C14.5223 15.5008 14.6977 15.5677 14.8754 15.5677C15.0531 15.5677 15.2308 15.5008 15.3646 15.3646ZM3.61615 15.3646L4.92231 14.0585C5.19231 13.7885 5.19231 13.35 4.92231 13.08C4.65231 12.81 4.21385 12.81 3.94385 13.08L2.63769 14.3862C2.36769 14.6562 2.36769 15.0946 2.63769 15.3646C2.77385 15.5008 2.94923 15.5677 3.12692 15.5677C3.30462 15.5677 3.48231 15.5008 3.61615 15.3646ZM14.0585 4.92L15.3646 3.61385C15.6346 3.34385 15.6346 2.90538 15.3646 2.63538C15.0946 2.36538 14.6562 2.36538 14.3862 2.63538L13.08 3.94154C12.81 4.21154 12.81 4.65 13.08 4.92C13.2162 5.05615 13.3915 5.12308 13.5692 5.12308C13.7469 5.12308 13.9246 5.05615 14.0585 4.92Z" />
        </svg>
    ),
    checked: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" stroke="currentColor" viewBox="0 0 26 19.33">
            <path d="M9.67,19.33c-.77,0-1.54-.29-2.12-.88L.88,11.79c-1.17-1.17-1.17-3.07,0-4.24s3.07-1.17,4.24,0l4.55,4.55L20.88.88c1.17-1.17,3.07-1.17,4.24,0,1.17,1.17,1.17,3.07,0,4.24l-13.33,13.33c-.59.59-1.35.88-2.12.88Z" />
        </svg>
    ),

    signin: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="" viewBox="0 0 18 18">
            <path d="M13.4061 8.42577C14.0356 7.52025 14.3669 6.47117 14.3669 5.36687C14.3669 2.40736 11.9595 0 9 0C6.04049 0 3.63313 2.40736 3.63313 5.36687C3.63313 6.47117 3.96442 7.52025 4.59386 8.42577C1.75583 10.016 0 13.0086 0 16.2773C0 17.227 0.773006 18 1.7227 18H16.2663C17.216 18 17.989 17.227 17.989 16.2773C17.989 13.0196 16.2331 10.027 13.3951 8.42577H13.4061ZM9 8.72393C7.14479 8.72393 5.64295 7.21104 5.64295 5.35583C5.64295 3.50061 7.15583 1.98773 9 1.98773C10.8442 1.98773 12.3571 3.50061 12.3571 5.35583C12.3571 7.21104 10.8442 8.72393 9 8.72393ZM11.8712 9.89448C14.2896 10.9877 15.8908 13.362 15.9902 16.0012H2.00982C2.1092 13.362 3.71043 10.9767 6.12883 9.89448C6.99018 10.4466 7.98405 10.7337 9 10.7337C10.016 10.7337 11.0098 10.4466 11.8712 9.89448Z" />
        </svg>
    ),
    setting: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z"
            />
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
        </svg>
    ),
    in: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
            />
        </svg>
    ),
    pdf: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Zm3.75 11.625a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
            />
        </svg>
    ),
    tracking: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" strokeWidth="1.5" stroke="currentColor">
            <path d="M5.62877 0L13.3614 3.52712L19.1259 0.52154V8.11827H17.2133V3.7485L14.3445 5.24432V8.11827H12.4319V5.28022L6.69408 2.66354V13.4862L8.9366 14.655L8.08071 16.44L5.77986 15.2393L0 18.8542V4.10949L5.62877 0ZM4.78149 13.5371V3.05245L1.91259 5.14659V15.3311L4.78149 13.5371ZM14.5835 11.6085C15.1035 11.6085 15.6117 11.7692 16.0441 12.0704C16.4765 12.3715 16.8135 12.7996 17.0127 13.3004C17.2119 13.8012 17.2642 14.3524 17.163 14.8842C17.0619 15.4161 16.8118 15.9047 16.4445 16.2884L16.4368 16.2964C16.1304 16.6142 15.7535 16.8483 15.3396 16.978C14.9257 17.1078 14.4875 17.1292 14.0638 17.0403C13.6401 16.9514 13.2439 16.7549 12.9103 16.4683C12.5767 16.1818 12.316 15.8139 12.1513 15.3972C11.9865 14.9805 11.9228 14.5279 11.9657 14.0795C12.0086 13.631 12.1569 13.2005 12.3973 12.826C12.6378 12.4515 12.9631 12.1446 13.3444 11.9324C13.7257 11.7202 14.1513 11.6093 14.5835 11.6095M18.4011 16.9196C19.009 15.9369 19.2468 14.7544 19.0687 13.5998C18.8906 12.4453 18.3092 11.4002 17.4365 10.6658C16.5637 9.9314 15.4613 9.55963 14.3415 9.62204C13.2216 9.68445 12.1635 10.1766 11.3708 11.0038C10.5781 11.831 10.1069 12.9348 10.0478 14.1026C9.98874 15.2704 10.346 16.4197 11.0509 17.3292C11.7558 18.2388 12.7584 18.8443 13.8658 19.0292C14.9731 19.2141 16.1069 18.9653 17.0489 18.3307L18.6459 20L20 18.5919L18.4011 16.9196Z" />
        </svg>
    ),
    speaker_wave: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.114 5.636a9 9 0 0 1 0 12.728M16.463 8.288a5.25 5.25 0 0 1 0 7.424M6.75 8.25l4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z"
            />
        </svg>
    ),
    arrow_down: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3" />
        </svg>
    ),
    bulk: (
        <svg viewBox="0 0 48 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M39.5 25C40.8807 25 42 23.8807 42 22.5C42 21.1193 40.8807 20 39.5 20C38.1193 20 37 21.1193 37 22.5C37 23.8807 38.1193 25 39.5 25Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                d="M18.5 25C19.8807 25 21 23.8807 21 22.5C21 21.1193 19.8807 20 18.5 20C17.1193 20 16 21.1193 16 22.5C16 23.8807 17.1193 25 18.5 25Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                d="M9.5 25C10.8807 25 12 23.8807 12 22.5C12 21.1193 10.8807 20 9.5 20C8.11929 20 7 21.1193 7 22.5C7 23.8807 8.11929 25 9.5 25Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path d="M42 23H47V13L45 6H39" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M34 23H21" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M44 13H36" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M46 18H44" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M16 23H12" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M4 23H0" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path
                d="M28.5 1H8.5C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16H28.5C32.6421 16 36 12.6421 36 8.5C36 4.35786 32.6421 1 28.5 1Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
        </svg>
    ),
    container: (
        <svg viewBox="0 0 48 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M39.5 27C40.8807 27 42 25.8807 42 24.5C42 23.1193 40.8807 22 39.5 22C38.1193 22 37 23.1193 37 24.5C37 25.8807 38.1193 27 39.5 27Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                d="M26.5 27C27.8807 27 29 25.8807 29 24.5C29 23.1193 27.8807 22 26.5 22C25.1193 22 24 23.1193 24 24.5C24 25.8807 25.1193 27 26.5 27Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                d="M5.5 27C6.88071 27 8 25.8807 8 24.5C8 23.1193 6.88071 22 5.5 22C4.11929 22 3 23.1193 3 24.5C3 25.8807 4.11929 27 5.5 27Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                d="M10.5 27C11.8807 27 13 25.8807 13 24.5C13 23.1193 11.8807 22 10.5 22C9.11929 22 8 23.1193 8 24.5C8 25.8807 9.11929 27 10.5 27Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path d="M42 25H47V15L45 8H37V19" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M34 25H29" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M44 15H37" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M46 20H44" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M33 1H1V18H33V1Z" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M5 15V6" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M9 15V6" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M13 15V6" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M17 15V6" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M21 15V6" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M25 15V6" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M29 15V6" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M21 22H0" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
        </svg>
    ),
    vehicle: (
        <svg viewBox="0 0 48 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M39 27C40.6569 27 42 25.6569 42 24C42 22.3431 40.6569 21 39 21C37.3431 21 36 22.3431 36 24C36 25.6569 37.3431 27 39 27Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                d="M12 27C13.6569 27 15 25.6569 15 24C15 22.3431 13.6569 21 12 21C10.3431 21 9 22.3431 9 24C9 25.6569 10.3431 27 12 27Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path d="M42 24H47V16L42 15L40 9H32V24H15" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M32 6V1H1V24H6" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M39 15H32" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M46 19H44" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
        </svg>
    ),
    other: (
        <svg viewBox="0 0 48 21" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
            <path
                d="M39.5 20C40.8807 20 42 18.8807 42 17.5C42 16.1193 40.8807 15 39.5 15C38.1193 15 37 16.1193 37 17.5C37 18.8807 38.1193 20 39.5 20Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                d="M26.5 20C27.8807 20 29 18.8807 29 17.5C29 16.1193 27.8807 15 26.5 15C25.1193 15 24 16.1193 24 17.5C24 18.8807 25.1193 20 26.5 20Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                d="M5.5 20C6.88071 20 8 18.8807 8 17.5C8 16.1193 6.88071 15 5.5 15C4.11929 15 3 16.1193 3 17.5C3 18.8807 4.11929 20 5.5 20Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                d="M10.5 20C11.8807 20 13 18.8807 13 17.5C13 16.1193 11.8807 15 10.5 15C9.11929 15 8 16.1193 8 17.5C8 18.8807 9.11929 20 10.5 20Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path d="M42 18H47V8L45 1H37V12" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M34 18H29" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M44 8H37" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M46 13H44" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M21 15H0" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M0 11H33" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
        </svg>
    ),
    bell_alert: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5"
            />
        </svg>
    ),
    start: (
        <svg viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1202_9937)">
                <path
                    d="M7.46164 1.42197C7.39655 1.27489 7.26054 1.18107 7.11059 1.18107H1.27765V0.756304C1.27765 0.521735 1.10329 0.331543 0.888243 0.331543C0.673198 0.331543 0.5 0.523002 0.5 0.757572V9.24265C0.5 9.47722 0.674361 9.66741 0.889405 9.66741C1.10445 9.66741 1.27881 9.47722 1.27881 9.24265V6.27313H7.11292C7.26287 6.27313 7.39887 6.1793 7.46396 6.03222C7.52906 5.88514 7.51046 5.71016 7.41747 5.58337L6.05629 3.7271L7.41747 1.87083C7.51046 1.74276 7.52906 1.56906 7.46396 1.42197H7.46164ZM5.25191 3.4621C5.13799 3.61679 5.13799 3.83741 5.25191 3.9921L6.30156 5.42361H1.27765V2.02932H6.30156L5.25191 3.46083V3.4621Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_1202_9937">
                    <rect width="7" height="9.33333" fill="white" transform="translate(0.5 0.333313)" />
                </clipPath>
            </defs>
        </svg>
    ),
    completed: (
        <svg viewBox="0 0 13 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1202_9943)">
                <path
                    d="M8.7252 0.177532C8.49208 -0.0591683 8.11372 -0.0591683 7.87702 0.172153L3.45502 4.54573L1.53094 2.5553C1.30141 2.3186 0.921252 2.31142 0.682759 2.54095C0.444265 2.77048 0.438885 3.15063 0.668413 3.38913L3.0139 5.8171C3.12508 5.93187 3.2775 5.99821 3.43889 6.00001H3.44606C3.60386 6.00001 3.75628 5.93725 3.86746 5.82607L8.72161 1.02571C8.95652 0.792595 8.9601 0.41244 8.72699 0.177532H8.7252Z"
                    fill="white"
                />
                <path
                    d="M6.61285 5.8171C6.72402 5.93187 6.87644 5.99821 7.03783 6.00001H7.045C7.2028 6.00001 7.35523 5.93725 7.4664 5.82607L12.3206 1.02571C12.5555 0.792595 12.5591 0.41244 12.3259 0.177532C12.0928 -0.0591683 11.7145 -0.0591683 11.4778 0.172153L7.05397 4.54573L6.89617 4.38255C6.66664 4.14406 6.28649 4.13868 6.04799 4.36821C5.8095 4.59774 5.80412 4.97789 6.03365 5.21638L6.61285 5.8171Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_1202_9943">
                    <rect width="12" height="6" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>
    ),
    error: (
        <svg viewBox="0 0 3 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.49414 1.66675V5.00008"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.49414 8.33325H1.50414"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    inProgress: (
        <svg viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.99888 4.1023C7.99357 1.89898 6.2022 0.108948 4.00021 0.108948C1.79822 0.108948 0.00153945 1.9043 0.00286836 4.07971C0.000210549 4.11825 -0.220388 8.02788 3.81549 9.85114C3.87529 9.87772 3.95901 9.89367 4.00021 9.89101C4.05735 9.89101 4.11582 9.88038 4.17031 9.85778C4.17695 9.85513 4.1836 9.85114 4.19024 9.84848C8.064 8.09566 8.01084 4.41991 7.99755 4.1023H7.99888ZM4.00154 8.95546C0.727121 7.36476 0.882603 4.2724 0.891905 4.11028C0.891905 2.39466 2.28592 0.997984 4.00154 0.997984C5.71715 0.997984 7.10984 2.39466 7.10984 4.11028C7.10984 4.11958 7.10984 4.13021 7.10984 4.13951C7.11782 4.2724 7.2733 7.36476 4.00154 8.95546Z"
                fill="white"
            />
            <path
                d="M4.00073 2.33221C3.02 2.33221 2.22266 3.12956 2.22266 4.11029C2.22266 5.09102 3.02 5.88836 4.00073 5.88836C4.98146 5.88836 5.7788 5.09102 5.7788 4.11029C5.7788 3.12956 4.98146 2.33221 4.00073 2.33221ZM4.00073 4.99932C3.51036 4.99932 3.11169 4.60065 3.11169 4.11029C3.11169 3.61992 3.51036 3.22125 4.00073 3.22125C4.4911 3.22125 4.88977 3.61992 4.88977 4.11029C4.88977 4.60065 4.4911 4.99932 4.00073 4.99932Z"
                fill="white"
            />
        </svg>
    ),
    /*
    question : (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
  <path strokeLinecap="round" strokeLinejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
</svg>

    )*/
};
